var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import moment from 'moment-timezone';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { SUCCESS_STATUS_CODE } from './service_helpers';
export var FILE_UPLOAD_DOC_TYPES = [
    { label: 'Financial Statements', value: '1' },
    { label: 'Bank Statements', value: '2' },
    { label: 'Tax Returns', value: '3' },
    { label: "Driver's License", value: '4' },
    { label: 'Voided checks', value: '5' },
    { label: 'Tax Exemption Certificates', value: '6' },
    { label: 'Invoice/Sales Order', value: '8' },
    { label: 'Other', value: '7' },
];
export var SUPPORTED_DOCUMENT_TYPES = '.docx,.xlsx,.pdf,.jpeg,.jpg';
var SUPPORTED_EXTENSIONS = ['docx', 'xlsx', 'pdf', 'jpg', 'jpeg'];
var SUPPORTED_MIME_TYPES = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpeg',
    'image/jpg',
];
var MAX_FILE_SIZE_MB = 25;
export var FILE_UPLOAD_HINT = 'Max file size: 25MB. Supported formats: .docx, .xlsx, .pdf, .jpeg, .jpg.';
var FILE_FORMAT_MESSAGE = 'This file format is not supported. Please choose a .docx, .xlsx, .pdf, .jpeg or .jpg file.';
var FILE_SIZE_MESSAGE = "The file is larger than ".concat(MAX_FILE_SIZE_MB, "MB. Please choose a smaller file.");
export var DOC_TYPE_REQUIRED_MESSAGE = 'Please select a document type.';
var UPLOAD_FAILED_MESSAGE = 'The document could not be uploaded. Please try again.';
export var REMOVE_FAILED_MESSAGE = 'The document could not be removed. Please try again.';
var UPLOAD_TIMEZONE = 'America/New_York';
var readExtension = function (fileName) { var _a; return ((_a = fileName.split('.').pop()) !== null && _a !== void 0 ? _a : '').toLowerCase(); };
export var findDocTypeLabel = function (docType) { var _a, _b; return (_b = (_a = FILE_UPLOAD_DOC_TYPES.find(function (option) { return option.value === docType; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''; };
export var validateDocumentFile = function (file) {
    if (!SUPPORTED_MIME_TYPES.includes(file.type) ||
        !SUPPORTED_EXTENSIONS.includes(readExtension(file.name))) {
        return FILE_FORMAT_MESSAGE;
    }
    if (file.size / 1000 / 1000 > MAX_FILE_SIZE_MB) {
        return FILE_SIZE_MESSAGE;
    }
    return '';
};
var toStoredFileName = function (docTypeLabel, fileName) {
    return "".concat(docTypeLabel.split(' ').join(''), "_").concat(fileName);
};
export var prepareDocumentFile = function (file, docTypeLabel, uploadedDocuments) {
    var storedName = toStoredFileName(docTypeLabel, file.name).toLowerCase();
    var isDuplicate = uploadedDocuments.some(function (document) { return document.fileName.toLowerCase() === storedName; });
    if (!isDuplicate) {
        return file;
    }
    var extension = readExtension(file.name);
    var nameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
    var stamp = moment().tz(UPLOAD_TIMEZONE).format('YYYYMMDDHHmmss');
    return new File([file], "".concat(nameWithoutExtension, "_").concat(stamp, ".").concat(extension), {
        type: file.type,
    });
};
var buildFormData = function (file, docType, context) {
    var formData = new FormData();
    formData.append('File', file);
    formData.append('DocType', docType);
    var append = function (name, value) {
        if (value) {
            formData.append(name, value);
        }
    };
    append('ApplicationId', context.applicationId);
    append('ApplicationType', context.applicationType);
    append('ProgramAspireOId', context.programAspireOId);
    append('ProgramId', context.programId);
    return formData;
};
export var uploadApplicationDocument = function (file, docType, context) { return __awaiter(void 0, void 0, void 0, function () {
    var docTypeLabel, response, data, error_1;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                docTypeLabel = findDocTypeLabel(docType);
                _g.label = 1;
            case 1:
                _g.trys.push([1, 3, , 4]);
                return [4, api_service.post({
                        endPoint: api_urls.UPLOAD_DOCUMENT,
                        payLoad: buildFormData(file, docType, context),
                        headerType: api_service.ContentHeaders.FormData,
                        showLoader: false,
                    })];
            case 2:
                response = _g.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE || !response.data.data) {
                    return [2, {
                            isSuccess: false,
                            document: null,
                            applicationId: '',
                            message: String((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : UPLOAD_FAILED_MESSAGE),
                        }];
                }
                data = response.data.data;
                return [2, {
                        isSuccess: true,
                        document: {
                            id: String((_d = data.Id) !== null && _d !== void 0 ? _d : ''),
                            fileName: String((_e = data.FileName) !== null && _e !== void 0 ? _e : file.name),
                            docType: docType,
                            docTypeLabel: docTypeLabel,
                            fileSize: file.size,
                            uploadedAt: new Date().toISOString(),
                        },
                        applicationId: String((_f = data.ApplicationId) !== null && _f !== void 0 ? _f : ''),
                        message: '',
                    }];
            case 3:
                error_1 = _g.sent();
                return [2, {
                        isSuccess: false,
                        document: null,
                        applicationId: '',
                        message: UPLOAD_FAILED_MESSAGE,
                    }];
            case 4: return [2];
        }
    });
}); };
export var deleteApplicationDocument = function (fileId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!fileId) {
                    return [2, true];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.delete({
                        endPoint: "".concat(api_urls.DELETE_DOCUMENT, "?FileId=").concat(encodeURIComponent(fileId)),
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                return [2, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === SUCCESS_STATUS_CODE];
            case 3:
                error_2 = _b.sent();
                return [2, false];
            case 4: return [2];
        }
    });
}); };
export var formatFileSize = function (bytes) {
    if (!Number.isFinite(bytes) || bytes < 0) {
        return '';
    }
    if (bytes >= 1024 * 1024) {
        return "".concat((bytes / (1024 * 1024)).toFixed(2), " MB");
    }
    if (bytes >= 1024) {
        return "".concat((bytes / 1024).toFixed(0), " KB");
    }
    return "".concat(bytes, " B");
};
export var formatUploadTimestamp = function (isoDate) {
    var uploadedAt = moment(isoDate);
    return uploadedAt.isValid() ? uploadedAt.tz(UPLOAD_TIMEZONE).format('MMM D, h:mm A') : '';
};
